module.exports = __webpack_public_path__ + "img/img_tongguo@2x.49cac820.png";